// Google Analytics configuration
export const GA_TRACKING_ID = 'G-KW232HS05P'; // Replace with your actual GA4 tracking ID

export const GA_CATEGORIES = {
  RESUME: 'resume',
  USER: 'user',
  TEMPLATE: 'template',
  DOWNLOAD: 'download',
  SHARE: 'share',
  NAVIGATION: 'navigation'
} as const;

export const GA_ACTIONS = {
  CREATE: 'create',
  UPDATE: 'update',
  EXIT: 'exit',
  SELECT: 'select',
  TIMING: 'timing',
  DELETE: 'delete',
  VIEW: 'view',
  DOWNLOAD: 'download',
  SHARE: 'share',
  CLICK: 'click'
} as const;

// AdSense configuration
export const ADSENSE_ID = 'ca-pub-2180566260470742'; // Replace with your AdSense publisher ID